export default __webpack_public_path__ + "7039704900973b1c5e5f4be0f4a0d3c6.svg";